import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

// Initialize animations and interactive elements once the page loads
document.addEventListener('DOMContentLoaded', () => {
  // For responsive design, make sure everything is centered and aligned properly
  const centerElements = document.querySelectorAll('h1, h2, h3, p');
  centerElements.forEach(element => {
    if (element instanceof HTMLElement) {
      element.style.textAlign = 'center';
    }
  });
  
  // Orbit animations should adapt to screen size
  const handleResize = () => {
    const orbitCircles = document.querySelectorAll('.orbit-circle');
    const windowWidth = window.innerWidth;
    
    orbitCircles.forEach((circle) => {
      if (circle instanceof HTMLElement) {
        if (windowWidth < 768) {
          circle.style.width = '60px';
          circle.style.height = '60px';
        } else {
          circle.style.width = '80px';
          circle.style.height = '80px';
        }
      }
    });
  };
  
  // Run once on load
  handleResize();
  
  // Update on window resize
  window.addEventListener('resize', handleResize);
});

reportWebVitals();
